module.exports = __webpack_public_path__ + "img/license.f976d04e.jpg";